import axios from 'axios';

class ADL {
  async getGroups() {
    const params = {
      method: 'get',
      url: 'im/api/contacts/groups'
    };
    const data = await this.ajax(params);
    return data;
  }

  async getUsers(id, page) {
    const params = {
      method: 'get',
      url: `/im/api/contacts/group-users?groupID=${id}&page=${page}`
    };
    const data = await this.ajax(params);
    return data;
  }

  async getUser(id) {
    const params = {
      method: 'get',
      url: `im/api/user-info?userID=${id}`
    };
    const data = await this.ajax(params);
    return data;
  }

  async getMessages(id) {
    const params = {
      method: 'get',
      url: `/im/api/messages?peerID=${id}`
    };
    const data = await this.ajax(params);
    return data;
  }

  async getMessagesLast(id, mesId, isGroup) {
    const params = {
      method: 'get',
      url: `/im/api/messages?lastMessageID=${mesId}&${
        isGroup ? 'groupID' : 'peerID'
      }=${id}`
    };
    const data = await this.ajax(params);
    return data;
  }

  async getMessagesStatus(mesIds) {
    const params = {
      method: 'post',
      url: `/im/api/messages/statuses`,
      data: {
        messageIDs: mesIds
      }
    };
    const data = await this.ajax(params);
    return data;
  }

  async getMessagesNewCount(peerIDs) {
    const params = {
      method: 'post',
      url: `/im/api/messages/new-count`,
      data: {
        peerIDs
      }
    };
    const data = await this.ajax(params);
    return data;
  }

  async sendMessage(message, recipients, groupId) {
    const payload = JSON.stringify({ message, recipients, groupId }).replace(
      /\|/g,
      '\\u007c'
    );
    const params = {
      method: 'post',
      url: '/im/api/messages/send',
      data: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    try {
      const response = await axios(params);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Ошибка. Попробуйте позже');
    }
  }

  async getSearch(str) {
    const params = {
      method: 'get',
      url: `/im/api/contacts/search?login=${str}`
    };
    const data = await this.ajax(params);
    return data;
  }

  async ajax(params) {
    try {
      const response = await axios(params);
      return response.data;
    } catch (e) {
      return null;
    }
  }

  async oldAjaxHack(params) {
    const response = await axios(params);
    const script = response.data
      .replace(/^Subsys_JsHttpRequest_Js\.dataReady/, '(function(){return arguments;})');
    const args = eval(script);
    return {
      scriptID: args[0],
      text: args[1],
      data: args[2]
    };
  }
}

export default ADL;
